import { gql } from '@apollo/client';

export const GetLapsWithCertificatesQuery = gql`
    query GetLapsWithCertificates($schoolId: ID, $platform: Platform) {
        getLapsWithCertificates(schoolId: $schoolId, platform: $platform) {
            certificatesUrl

            lap {
                id
                name
                from
                to

                course {
                    id
                    name
                }
            }
        }
    }
`;
